import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Include scripts for analytics.
 * Note: When adding new external scripts/styles/fonts/etc.,
 *       if a Content Security Policy (CSP) is turned on, the new URLs
 *       should be whitelisted in the policy. Check: server/csp.js
 */
export const IncludeScripts = props => {
  const { analytics } = props?.config || {};
  const { plausibleDomains } = analytics || {};

  // Collect relevant analytics libraries
  let analyticsLibraries = [];

  if (plausibleDomains) {
    // If plausibleDomains is not an empty string, include their script too.
    analyticsLibraries.push(
      <script
        key="plausible"
        defer
        src="https://plausible.io/js/script.js"
        data-domain={plausibleDomains}
        crossOrigin
      ></script>
    );
  }

  return <Helmet>{analyticsLibraries}</Helmet>;
};
